import React from 'react';

import { RecursiveMenu } from '@uncinc/react-drupal-core';

import './style.scss';

const MegaMenuTopMenu: React.FC = () => (
  <div className="MegaMenu__TopMenu">
    <RecursiveMenu
      menuId="main"
      maxLevel={1}
    />
  </div>
);

export default MegaMenuTopMenu;
